import clsx from 'clsx'
import { lazy, Suspense } from 'react'

import { FvLinkButton } from '@fv/client-components'
import type { FullShipment } from '@fv/client-types'

import { useHasUnreadMessagesOnLoad } from '@/features/messages/queries'
import type { QuoteRequestResponse } from '@/hooks/shipments/useQuoteRequestResponses'

import { ListItem } from '../List'
import { Loading } from '../Loading'

const MiniMessageApp = lazy(() => import('@/features/messages/MiniMessageApp'))

type Props = {
  carrier: QuoteRequestResponse
  hasNewActivity?: boolean
  isActive?: boolean
  load: Pick<FullShipment, 'loadId'>
  setActiveQuoteId: (id: string | null) => void
}

const InactiveCarrierListItem = ({
  carrier,
  hasNewActivity,
  isActive,
  load,
  setActiveQuoteId,
}: Props) => {
  const { loadId } = load
  const { carrierId, id, name, userId } = carrier
  const hasUnreadMessages = useHasUnreadMessagesOnLoad({
    carrierId,
    loadId,
    userId,
  })

  return (
    <ListItem className="flex-wrap">
      <div className="flex items-center w-full">
        <div>{name}</div>
        <div className="ml-auto flex">
          <div className="!relative">
            {hasUnreadMessages && (
              <div className="shipment-list-pricing__unread-indicator" />
            )}

            <FvLinkButton
              onClick={() => {
                setActiveQuoteId(isActive ? null : id)
              }}
              icon={hasUnreadMessages ? 'comment-alt-dots' : 'comment-alt'}
              iconClass={clsx({ pulse: hasNewActivity })}
            />
          </div>
        </div>
      </div>

      {isActive && (
        <div className="mt-4 w-full">
          <Suspense fallback={<Loading />}>
            <MiniMessageApp
              loadId={loadId}
              carrierId={carrierId}
              carrierName={name}
            />
          </Suspense>
        </div>
      )}
    </ListItem>
  )
}

export default InactiveCarrierListItem
